<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-12-28 16:55:19
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-28 16:55:25
 * @FilePath: /chaoyongtuan/src/views/secondColonelManage/cooperativeColonel/list/components/tableCell/followInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div class="yx-color-text-primary font-h6-regular">
			<el-tooltip placement="top" :content="row.partner_role_name" v-ak-tooltip-auto-show>
				<p class="line-ellipsis-1" style="width: 100%">{{ row.partner_role_name }}</p>
			</el-tooltip>
			<p>{{ row.add_time }}</p>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
};
</script>
